jQuery(function ($) {
	//Mostrar el modal de bienvenida del usuario
	//El control de la variable	welcome_params se realiza en functions.php
	if(typeof(welcome_params) !== "undefined" && typeof(welcome_params['show_welcome_popup']) !== "undefined") {
		$('#welcome_modal').modal('show');

		let resource = $('.post_content .text-center .button-blue').attr('href');
		let btn_resource = $('.btn_download_resource');

		btn_resource.on('click', function(){
			window.location.href = resource;
		})
	}

	//Antes de mostrar el modal de usuario/inicio determinar el formulario a mostrar
	$('#signUp_modal').on('show.bs.modal', function (event) {
	  // Button that triggered the modal
	  var button = $(event.relatedTarget)

	  var sign_type = $(button).attr('data-sign-type')
	  switchSignForm(sign_type);

	  return;
	})

	$(".modal_signin").on("click", function() {
		switchSignForm($(this).attr("data-target"));
	})
	
	function switchSignForm(target) {
	  if(target == "signup") {
	  	$(".type-ebook").hide();
	  	$(".type-signin").hide();
	  	$(".type-signup").show();	  	
	  } else if(target == "signin") {
	  	$(".type-ebook").hide();
	  	$(".type-signin").show();
	  	$(".type-signup").hide();
	  } else if(target == "ebook") {
	  	$(".type-signin").hide();
	  	$(".type-signup").hide();
	  	$(".type-ebook").show();
	  }
	}

/*
	$("#signup-form").on("submit", function() {
		signup();
		return false;
	})
*/
	var signup_form = $("#signup-form");
  var form_validator = $(signup_form).validate({
    errorElement: 'small',
    rules: {      
      rg_name: 	{ required: true },
      rg_email: { required: true, email: true },
      rg_phone: { required: true },
      rg_type_doc: { required: true },
      rg_doc: 	{ required: true },
      rg_position: { required: true },
      rg_tratamiento_modal: { required: true }
    },
    messages: {      
      rg_name:  {
        required: "Este campo es obligatorio"
      },
			rg_email:  {
        required: "Este campo es obligatorio",
        email: "Debe ser un correo electrónico válido"
      },
			rg_type_doc:  {
        required: "Este campo es obligatorio",
      },
      rg_phone:  {
        required: "Este campo es obligatorio"
      },
      rg_doc: {
      	required: "Este campo es obligatorio"
      },
      rg_position: {
      	required: "Este campo es obligatorio"
      },
      rg_tratamiento_modal: {
      	required: "Por favor acepta la política de tratamiento de datos"
      }
    },
    submitHandler: function(form){
    	signup();

      //Prevenir el submit del form
      return false;
    }
  });

	//Controlar los pasos del formulario de registro
	$("#signup-form .btn-next, #ebook-form .btn-next").on("click", function() {
		if($(signup_form).valid()) {
			signup_NextStep( $(this) );
			$('.modal .info-container').hide();
			$('.modal .form-container').addClass('full_cnt');
			$('.btn_error').removeClass('show_login_btn');
		}		
	})

	//Controlar los pasos del formulario de registro
	$("#signup-form .btn-prev").on("click", function() {
		signup_PrevStep( $(this) );
		$('.modal .info-container').show();
		$('.modal .form-container').removeClass('full_cnt');
	})

	function signup_PrevStep(target) {				
		$(target).closest("div.step").removeClass('active');
		$(target).closest("div.step").prev().addClass('active')		
	}

	function signup_NextStep(target) {				
		$(target).closest("div.step").removeClass('active');
		$(target).closest("div.step").next().addClass('active')		
	}	

	// Resetear formulario
	$("#signup-form .btn-prev").on("click", function() {
		$('.btn_error').removeClass('show_login_btn');
		$("#signup-form").trigger("reset");
		$('#signup-form .msg_error_register').text('');
		$('#signup-form #vs_form_submit').show();
	});

	//Realizar el registro del usuario via AJAX
	//Si el registro es exitoso, redirige al usuario al home del portal
	function signup() {
		var submit_button = $("#signup-form").find('input[type="submit"]')

		var postData = $("#signup-form").serialize();

    $.ajax({
      url 			: moduleUser.signup,
      dataType 	: 'json',
      type 			: "POST",
      data 			: postData,

      beforeSend : function(xhr) {
        submit_button.hide();
        submit_button.parent().find(".form-submit-loading").show()
      },
      success:function(data) {
      	if(typeof(data['redirect_to']) !== "undefined") {
	      	const param_caracter = data['redirect_to'].includes("?") ? "&" : "?";
	      	window.location.href = data['redirect_to'] + param_caracter + "register_success=1";      		
      	} else {
      		window.location.href = wpData.siteURL + "?register_success=1";
      	}
      },
			error: function(err){

				let response_data = err.responseJSON;

				if( response_data.userExists ) {
					$('#signup-form .btn_error').addClass('show_login_btn'); // Mostrar boton de iniciar sesión
					$('#signup-form .form-submit-loading').hide();
					$('#signup-form .msg_error_register').text( response_data.message );
					$("#signup-form").trigger("reset");
				}


			}
    });			
	}



	//Realizar el login via AJAX
	//Si el login es exitoso, redirige al usuario al home del portal
	$('form[name="signin-form"]').on("submit", function() {
		signin($(this));
		return false;
	})	
	function signin(form) {
		var submit_button = $(form).find('input[type="submit"]')

		var postData = $(form).serialize();
    $.ajax({
      url 			: moduleUser.signin,
      dataType 	: 'json',
      type 			: "POST",
      data 			: postData,

      beforeSend : function(xhr) {
        submit_button.hide();
        submit_button.parent().find(".form-submit-loading").show()

        //ocultar mensaje de error de login si esta presente
        $(".wrong-user").hide();
      },
      success:function(data) {
      	if(data['status'] == true) {

	      	if(typeof(data['redirect_to']) !== "undefined") {
						const param_caracter = data['redirect_to'].includes("?") ? "&" : "?";
						let showDownloadPopup = moduleUser.isEbookOrInfografia ? 'showDownloadPopup=1' : '';
		      	window.location.href = data['redirect_to'] + param_caracter + showDownloadPopup;
						
	      	} else {
	      		window.location.href = wpData.siteURL;
	      	}
      		
      	} else {
      		//Ocultar loading boton y mostrar de nuevo el boton de submit
	        submit_button.show();
	        submit_button.parent().find(".form-submit-loading").hide()

	        //mostrar mensaje de error de login
      		$(".wrong-user").show();
      	}
      }
    });			
	}
});